import { VehicleWarningsMfe } from '@/features/microfrontends/VehicleWarningsMfe';
import VehicleWarningsSidebar from '@/features/vehicleWarnings/VehicleWarningsSidebar';
import { Asset, Product } from '@/generated/fleetAggregationServiceTypes';
import { FeatureToggle, useFeatureToggle } from '@/hooks/useFeatureToggle';

type VehicleWarningsProps = {
    asset: Asset;
};

const VehicleWarnings = ({ asset }: VehicleWarningsProps) => {
    const { featureToggleValue: isServiceCareLAlphaFeatureEnabled } = useFeatureToggle(FeatureToggle.ENABLE_SERVICE_CARE_L_ALPHA);
    if (!isServiceCareLAlphaFeatureEnabled || asset.product !== Product.ServiceCareL) {
        return null;
    }
    return (
        <>
            <VehicleWarningsMfe assetId={asset.id} />
            <VehicleWarningsSidebar asset={asset} />
        </>
    );
};

export default VehicleWarnings;
